import { useEffect } from 'react';

export const useDebouncedEffect = (callback: Function, deps: unknown[], debounceTime = 500) =>
	useEffect(() => {
		const t = setTimeout(callback, debounceTime);
		return () => clearTimeout(t);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
